var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { APP_ROUTES, LogoIcon, LogoTextIcon, PageLoader } from '@core';
import { AUTH_ROUTES } from '@features/auth/constants';
import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
export var AuthorizationScreen = function () {
    var navigate = useNavigate();
    useEffect(function () {
        if (!location.pathname.startsWith("/auth/login"))
            navigate("".concat(APP_ROUTES.auth.route, "/").concat(AUTH_ROUTES.login.route));
    }, []);
    return (_jsxs("div", __assign({ className: "flex min-h-screen w-full flex-col" }, { children: [_jsxs("div", __assign({ className: "flex h-[64px] w-full flex-row items-center gap-[10px] px-[25px]" }, { children: [_jsx(LogoIcon, {}), _jsx(LogoTextIcon, {})] })), _jsx("div", __assign({ className: "flex justify-center pt-[40px]" }, { children: _jsx(Suspense, __assign({ fallback: _jsx(PageLoader, {}) }, { children: _jsx(Outlet, {}) })) }))] })));
};
